import { render } from "./CompaniesTab.vue?vue&type=template&id=50d47384"
import script from "./CompaniesTab.vue?vue&type=script&lang=js"
export * from "./CompaniesTab.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fci/Downloads/traininGulftic-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__